<template>
    <div>
      <vue-good-wizard 
        :steps="steps"
        :onNext="nextClicked" 
        :onBack="backClicked"
        :nextStepLabel="nextStepLabel"
        :previousStepLabel="previousStepLabel"
        :finalStepLabel="finalStepLabel">
        <div slot="page1">
          <div class="form-datos">
              
            <div class="input">
                <label for="sentencia">Origen del estudio *</label>
                <select class="form-select" id="sentencia" v-model="proceso.sentencia">
                    <option value="Sentencia">Sentencia</option>
                    <option value="Concilación">Concilación</option>
                </select>
            </div>
            <div class="input">
                <label for="sentencia">Jurisdicción*</label>
                <select class="form-select" id="sentencia" v-model="proceso.jurisdiccion">
                    <option value="Ordinaria">Ordinaria</option>
                    <option value="Contenciosa Administrativa">Contenciosa Administrativa</option>
                </select>
            </div>
              <!-- <div class="input" :class="{invalid: $v.proceso.jurisdiccion.$error}">
                  <label for="jurisdiccion">Jurisdicción *</label>
                  <input type="text" id="jurisdiccion" @blur="$v.proceso.jurisdiccion.$touch()" placeholder="Ordinaria o Contensioso Administrativa" class="form-control required" v-model="proceso.jurisdiccion"/>
              </div> -->
              <div class="input" :class="{invalid: $v.proceso.afiliado.$error}">
                  <label for="afiliado">Nombre Demandante *</label>
                  <input type="text" id="afiliado" @blur="$v.proceso.afiliado.$touch()" placeholder="Afiliado" class="form-control required" v-model="proceso.afiliado"/>
              </div>
              <div class="input" :class="{invalid: $v.proceso.cedula.$error}">
                  <label for="cedula">Identificación *</label>
                  <input type="text" id="cedula" @blur="$v.proceso.cedula.$touch()" placeholder="Cédula" class="form-control required" v-model="proceso.cedula"/>
              </div>
              <div class="input" :class="{invalid: $v.proceso.radicado.$error}">
                  <label for="radicado">Radicado *</label>
                  <input type="text" id="radicado" @blur="$v.proceso.radicado.$touch()" placeholder="Radicado" class="form-control required" v-model="proceso.radicado"/>
              </div>
              <div class="input" :class="{invalid: $v.proceso.despacho1.$error}">
                  <label for="desacho1">Despacho 1a instancia *</label>
                  <input type="text" id="despacho1" @blur="$v.proceso.despacho1.$touch()" placeholder="Despacho primera instancia" class="form-control required" v-model="proceso.despacho1"/>
              </div>
              <div class="input" >
                  <label for="desacho2">Despacho 2a instancia *</label>
                  <input type="text" id="despacho2" @blur="$v.proceso.despacho2.$touch()" placeholder="Despacho segunda instancia" class="form-control required" v-model="proceso.despacho2"/>
              </div>
              <div class="input" :class="{invalid: $v.proceso.fechaFallo1.$error}">
                  <label for="fecha1">Fecha Fallo 1a instancia *</label>
                  <input type="text" id="fecha1" @blur="$v.proceso.fechaFallo1.$touch()" placeholder="Fecha Fallo primera instancia" class="form-control required" v-model="proceso.fechaFallo1"/>
              </div> 
              <div class="input" >
                  <label for="fecha2">Fecha Fallo 2a instancia *</label>
                  <input type="text" id="fecha2" @blur="$v.proceso.fechaFallo2.$touch()" placeholder="Fecha Fallo segunda instancia" class="form-control required" v-model="proceso.fechaFallo2"/>
              </div>
                <div>
                    <input type="checkbox" id="casacion" v-model="proceso.casacionChecked">
                    <label for="casacion">Casación</label>
                    <input type="checkbox" id="modifica" v-model="proceso.modificaChecked">
                    <label for="modifica">Modifica</label>
                    <input type="checkbox" id="revoca" v-model="proceso.revocaChecked">
                    <label for="revoca">Revoca</label>
                    <input type="checkbox" id="confirma" v-model="proceso.confirmaChecked">
                    <label for="confirma">Confirma</label>
                </div>

                <div :class="{ hidden: !proceso.casacionChecked, visible: proceso.casacionChecked }">
                <div class="input">
                    <label for="casacionInput">Casación:</label>
                    <input type="text" id="casacionInput" v-model="proceso.casacion">
                </div>
                <div class="input">
                    <label for="fechaCasacion">Fecha Casación:</label>
                    <input type="date" id="fechaCasacion" v-model="proceso.fechaCasacion1" @change="formatFechaCasacion">
                </div>
                </div>
              <!-- <div class="input" :class="{invalid: $v.proceso.pretension.$error}">
                  <label for="pretension">Pretensión *</label>
                  <input type="text" id="pretension" @blur="$v.proceso.pretension.$touch()" placeholder="Pretensión" class="form-control required" v-model="proceso.pretension"/>
              </div> -->
              <div class="input">
                <label for="pretension">Pretension:</label>
                <select class="form-select" id="pretension" v-model="proceso.pretension1" @change="updateOptions">
                <option v-for="option in pretensionOptions" :value="option">{{ option }}</option>
                </select>
              </div>
              <div class="input">
                <label for="dependent">Clase:</label>
                <select class="form-select" id="dependent" v-model="proceso.clasePretension" @change="updatePretensionText">
                <option v-for="option in dependentOptions" :value="option">{{ option }}</option>
                </select>
              </div>
          </div>
        </div>
        <div slot="page2">
          <div class="form-datos">
            <h4>Presunto Responsable</h4>
            <!-- <div :class="{ hidden: responsable.silencioAdministrativo }"> -->
              <!-- <div class="input" :class="{invalid: $v.responsable.nombre.$error, disabled: this.responsable.silencioAdministrativo}" >
                  <label for="responsable">Nombre *</label>
                  <input type="text" id="responsable" @blur="$v.responsable.nombre.$touch()" placeholder="Nombre" class="form-control required" v-model="responsable.nombre" :disabled="responsable.silencioAdministrativo"/>
              </div> -->
              <div class="input" :class="{invalid: $v.responsable.nombre.$error, disabled: this.responsable.silencioAdministrativo}">
                <label for="responsable1">Nombre *</label>
                <b-form-input list="responsable1" v-model="responsable.nombre" :disabled="responsable.silencioAdministrativo" autocomplete="off"></b-form-input>
                <datalist id="responsable1">
                  <option v-for="presuntoName in presuntoResponsableNamesArray">{{ presuntoName }}</option>
                </datalist>
              </div>
              <div class="input" :class="{invalid: $v.responsable.cargo.$error}">
                  <label for="responsableCargo">Cargo *</label>
                  <input type="text" id="responsableCargo" @blur="$v.responsable.cargo.$touch()" placeholder="Cargo" class="form-control required" v-model="responsable.cargo" :disabled="responsable.silencioAdministrativo"/>
              </div>
            <!-- </div> -->
              <span @click="updateSilencioAdministrativo"><input type="checkbox" id="SilecioAdmin" v-model="responsable.silencioAdministrativo" @click="updateSilencioAdministrativo">
                <label @click="updateSilencioAdministrativo" for="SilecioAdmin">Silencio administrativo</label>
              </span>
              <div class="input" :class="{invalid: $v.aoe.$error}">
                  <h4 for="aoe">Acto Objeto de Estudio *</h4>
                  <input type="text" id="aoe" @blur="$v.aoe.$touch()" placeholder="Acto Objeto de Estudio" class="form-control required" v-model="aoe.oae" :disabled="responsable.silencioAdministrativo"/>
                  <label for="responsableCargo">Sustanciador *</label>
                  <input type="text" id="aoe2" @blur="" placeholder="Sustanciador" class="form-control required"  v-model="aoe.sustanciador" :disabled="responsable.silencioAdministrativo"/>
                  <label for="responsableCargo">Revisor *</label>
                  <input type="text" id="aoe3" @blur="" placeholder="Revisor" class="form-control required"  v-model="aoe.revisor" :disabled="responsable.silencioAdministrativo"/>
              </div>
              <h4>Cumplimiento</h4>
              <div class="input" :class="{invalid: $v.cumplimiento.acto.$error}">
                  <label for="actoCumplimiento">Acto de Cumplimiento *</label>
                  <input type="text" id="actoCumplimiento" @blur="$v.cumplimiento.acto.$touch()" placeholder="Acto de Cumplimiento" class="form-control required" v-model="cumplimiento.acto" />
              </div>
              <div class="input" :class="{invalid: $v.cumplimiento.fechaPago.$error}">
                  <label for="fechaPago">Fecha Pago *</label>
                  <input type="text" id="fechaPago" @blur="$v.cumplimiento.fechaPago.$touch()" placeholder="Fecha Pago" class="form-control required" v-model="cumplimiento.fechaPago" />
              </div>
              <div class="input" :class="{invalid: $v.cumplimiento.valorNeto.$error}">
                  <label for="valorNeto">Valor Neto *</label>
                  <input type="text" id="valorNeto" @blur="$v.cumplimiento.valorNeto.$touch()" placeholder="Valor Neto" class="form-control required" v-model="cumplimiento.valorNeto" />
              </div>
          </div>
        </div>
        <div slot="page3">
          <div class="form-datos">
            <h4>Sentido de la condena</h4>
              <div class="input" >
                  <!-- <label for="cuantiaDeLaPension">Cuantia de la Pension *</label>
                  <input type="text" id="cuantiaDeLaPension" @blur="$v.cuantiaDeLaPension.$touch()" placeholder="Cuantia de la Pension" class="form-control required" v-model="cuantiaDeLaPension" /> -->
                  <textarea type="textarea" rows="3" id="parrafo1" @blur="$v.customText.sentidoDeLaCondena.$touch()" placeholder="Sentido de la condena" class="form-control required" v-model="customText.sentidoDeLaCondena2" />
              </div>
              <h4>Antecedentes</h4>
              <div class="input" >
                  <textarea type="textarea" rows="11" id="parrafo2" @blur="$v.customText.antecedentes.$touch()" placeholder="Antecedentes" class="form-control required" v-model="customText.antecedentes" />
              </div>
          </div>
        </div>
        <div slot="page4">
          <div class="form-datos">
            <h4>Modificaciones </h4>
            <!-- <div class="input" >
                  <label for="parrafo3">Analisis 1 *</label>
                  <textarea type="textarea" rows="6" id="parrafo3" @blur="$v.customText.analisis1.$touch()" placeholder="Analisis 1" class="form-control required" v-model="customText.analisis1" />
              </div> -->
              <div class="input" >
                  <label for="parrafo4">Analisis *</label>
                  <textarea type="textarea" rows="16" id="parrafo4" @blur="$v.customText.analisis1.$touch()" placeholder="Analisis" class="form-control required" v-model="customText.analisis3" />

                <!-- <div id="textarea" >
                    <div contenteditable="true" class="editInsideDiv" @blur="updateModelAnalisis1" @click.stop="handleClickEdit">{{customText.analisis1}}</div>
                    <div style="color:grey; cursor: not-allowed;" contenteditable="false" @click.stop="handleClickNonEdit">{{customText.analisisNonEditable}}</div>
                    <div class="editInsideDiv" contenteditable="true" @blur="updateModelAnalisis2" @click.stop="handleClickEdit">{{customText.analisis2}}</div>
                </div> -->
              </div>
          </div>
        </div>
        <div slot="page5">
          <div class="form-datos">
              <div class="input" :class="{invalid: !acceptTerms}"><input id="acceptTerms" name="acceptTerms" type="checkbox" v-model="acceptTerms"> <label for="acceptTerms" class="checkbox-label">Acepto los terminos y condiciones.</label></div>
              <iframe id='pdfV' style="width:100%; height: 500px" > </iframe>
              <button class="btn btn-success" @click="downloadPretension()">Descargar</button>
          </div>
        </div>
      </vue-good-wizard>
    </div>
  </template>
  
  <script>
  import { required, email, numeric, minValue, minLength, sameAs, requiredUnless } from 'vuelidate/lib/validators'
  import fireStore from '../../helpers/db'
import pretension from '../../contractTemplates/pretensionAvanzado';
import pretensionSilencioAdministrativo from '../../contractTemplates/pretensionSilencioAdministrativo';
import presuntoResponsables from './auxFiles/presuntosResponsable';
  export default {
    data(){
      return {
        fileName: 'pretensionJunio',
        proceso: {
            sentencia: 'Sentencia',
            jurisdiccion: 'Ordinaria',
            afiliado: '',
            cedula: '',
            radicado: '',
            despacho1: '',
            despacho2: 'n/a',
            fechaFallo1: '',
            fechaFallo2: 'n/a',
            pretension: 'Vejez - Indemnización Sustitutiva - Reliquidación',
            pretension1: 'Vejez',
            clasePretension: 'Indemnización Sustitutiva - Reliquidación',
            tipoDemanda: 'demanda',
            casacionChecked: false,
            modificaChecked:false,
            revocaChecked:false,
            confirmaChecked:false,
            casacion: 'Sala Laboral - Corte Suprema de Justicia',
            fechaCasacion: '',
            fechaCasacion1: '',
        },
        responsable:{
            nombre: '',
            cargo: '',
            silencioAdministrativo: false
        },
        aoe: {
            oae: '',
            sustanciador: '',
            revisor: ''
        },
        cumplimiento:{
            acto: '',
            fechaPago: '',
            valorNeto: ''
        },
        cuantiaDeLaPension: '$XXXX',
        antecedentes:{
            reconocimiento: 'XXXX',
            cuantiaInicial: '$XXXX',
            numeroSemanas: 'XXXX'
        },
        customText:{
            antecedentes: "",
            sentidoDeLaCondena: "",
            sentidoDeLaCondena2: "",
            analisis1: "",
            analisis2: "",
            analisis3: "",
            analisisNonEditable: "",
            recomendacion1: "",
        },
        acceptTerms: true,
        steps: [
            {
            label: 'Información del proceso judicial',
            slot: 'page1',
            },
            {
            label: 'Presunto Responsable/AOE/Cumplimiento',
            slot: 'page2',
            },
            {
            label: 'Sentido de la condena/Antecedentes',
            slot: 'page3',
            },
            {
            label: 'Modificaciones',
            slot: 'page4',
            },
            {
            label: 'Terminar',
            slot: 'page5',
            }
        ],
        nextStepLabel: 'Siguiente',
        previousStepLabel: 'Atras',
        finalStepLabel: 'Generar',
        pretensionOptions: [
          'Vejez', 'Invalidez', 'Sobrevivientes', 'Auxilios_Funerarios', 
          'Afiliación', 'Mora_Patronal', 'Conflictos_De_Competencia', 
          'Colpensiones_Patrono', 'Otros', 'Iss_Patrono', 'Reliquidación'
        ],
        dependentOptions: [],
        selectedPretension: '',
        selectedDependent: '',
        optionsMap: {
            'Vejez': [
            'Decreto 546 De 1971', 'Decreto 2701 De 1988', 'Decreto 929 De 1978', 
            'Decreto 758 De 1990', 'Magistrados De Altas Cortes Ley 4A De 1992', 
            'Decreto 3041 De 1966', 'Ley 100 De 1993', 'Ley 33 De 1985', 
            'Ley 71 De 1988', 'Incrementos Pensionales 7%', 'Incrementos Pensionales 14%', 
            'Incrementos Pensionales 7% Y 14%', 'Ministerio De Relaciones Exteriores', 
            'Alto Riesgo', 'Compatibilidad Origen Común Y Origen Profesional', 
            'Compartidas', 'Conmutadas', 'Intereses Moratorios', 
            'Indemnización Sustitutiva - Prescripción', 
            'Indemnización Sustitutiva - Requisitos', 
            'Indemnización Sustitutiva - Reliquidación', 'Tope 25 Smlmv', 
            'Retroactivo', 'Pensión Familiar', 'Recuperacion De Semanas', 
            'Cálculo Actuarial Para Financiar Una Pensión Reconocida En El Rpm (Empleador Publico)', 
            'Bonos Pensionales Por Pagar Y Por Cobrar', 'Reliquidacion', 'Reliquidacion 80%',
            'Ley 797 De 2003', 'Indexacion', 'Retroactivo'
          ],
          'Invalidez': [
            'Intereses Moratorios', 'Retroactivo', 'Indemnización Sustitutiva - Prescripción',
            'Indemnización Sustitutiva - Requisitos', 'Indemnización Sustitutiva - Reliquidación',
            'Decreto 758 De 1990 - Condicion Mas Beneficiosa', 'Ley 797 De 2003 - Progresividad',
            'Ley 860 De 2003 - Progresividad', 'Enfermedad Degenerativa - Catastrófica O Congenita',
            'Fidelidad', 'Incapacidades'
          ],
          'Sobrevivientes': [
            'Intereses Moratorios', 'Retroactivo', 'Indemnización Sustitutiva - Prescripción',
            'Indemnización Sustitutiva - Requisitos', 'Indemnización Sustitutiva - Reliquidación',
            'Convivencia Parejas Del Mismo Sexo', 'Conflicto De Convivencia',
            'Decreto 758 De 1990 - Condicion Mas Beneficiosa', 'Ley 797 De 2003 - Progresividad',
            'Ley 860 De 2003 - Progresividad', 'Sobrevivientes - Hijo Invalido'
          ],
          'Auxilios_Funerarios': [
            'Requisitos', 'Requisitos_No_Activo', 'Prescripción', 'Intereses Moratorios'
          ],
          'Afiliación': [
            'Recuperación Régimen De Transición', 'Multivinculación', 'Omisión De Afiliación', 
            'Traslado De Régimen'
          ],
          'Mora_Patronal': ['Mora_Patronal'],
          'Conflictos_De_Competencia': ['Conflicto De Competencia'],
          'Colpensiones_Patrono': ['Contrato Realidad'],
          'Otros': [
            'Regimen Especial Das', 'Pago Costas', 'Regimen Especial Inpec', 
            'Cuotas Partes Pensionales Por Cobrar Y Por Pagar', 
            'Devolución De Aportes En Virtud De La Ley 549 De 1999, Por Cobrar Y Por Pagar', 
            'Liquidación Financiera Por Sentencia De Reintegros Y Contrato Realidad', 
            'Cálculo Actuarial Por Omisión De Afiliación', 'Otros'
          ],
          'Iss_Patrono': ['Contrato Realidad'],
          'Reliquidación': [
            'Decreto 546 De 1971', 'Decreto 2701 De 1988', 'Decreto 929 De 1978', 
            'Decreto 758 De 1990', 'Magistrados De Altas Cortes Ley 4A De 1992', 
            'Decreto 3041 De 1966', 'Ley 100 De 1993', 'Ley 33 De 1985', 
            'Ley 71 De 1988', 'Incrementos Pensionales 7%', 'Incrementos Pensionales 14%', 
            'Incrementos Pensionales 7% Y 14%', 'Ministerio De Relaciones Exteriores', 
            'Alto Riesgo', 'Compatibilidad Origen Común Y Origen Profesional', 
            'Compartidas', 'Conmutadas', 'Intereses Moratorios', 
            'Indemnización Sustitutiva - Prescripción', 
            'Indemnización Sustitutiva - Requisitos', 
            'Indemnización Sustitutiva - Reliquidación', 'Tope 25 Smlmv', 
            'Retroactivo', 'Pensión Familiar', 'Recuperacion De Semanas', 
            'Cálculo Actuarial Para Financiar Una Pensión Reconocida En El Rpm (Empleador Publico)', 
            'Bonos Pensionales Por Pagar Y Por Cobrar', 'Reliquidacion', 
            'Ley 797 De 2003', 'Indexacion'
          ]
        },
        processPreliminarText: true,
        presuntoResponsableNamesArray : presuntoResponsables,
      };
    },
    computed: {
      uploadedData () {
        return !this.$store.getters.activePretension ? null : this.$store.getters.activePretension
      },
      isOptional() {
        return true//!this.responsable.silencioAdministrativo;
      },
      user(){
        return !this.$store.getters.user ? {uid:'-23'} : this.$store.getters.user
      },
      analisComplete(){
        return `${this.customText.analisis1}

${this.customText.analisisNonEditable}

${this.customText.analisis2}`; 
      }
    },
    
    methods: {
      created () {
        console.log('Entro a Pretension')
      },
      nextClicked(currentPage) {
        console.log('next clicked', currentPage)
        switch(currentPage){
            case 0:
              this.$v.proceso.$touch()
              if(this.$v.proceso.$invalid)
                  return false;
            break;
            case 1:
              this.$v.responsable.$touch()
              if(this.$v.responsable.$invalid ||this.$v.aoe.$invalid)
                  return false;
                if(this.processPreliminarText){
                  this.customText.sentidoDeLaCondena = this.sentidoDeLaCondenaText();
                  this.customText.sentidoDeLaCondena2 = this.sentidoDeLaCondena2Text();
                  this.customText.antecedentes = this.antecedentesText();
                  this.customText.analisis1 = this.analisis1Text();
                  this.customText.analisis2 = this.analisis2Text();
                  this.customText.analisisNonEditable = this.analisisNonEditableText();
                  this.customText.analisis3= this.analisComplete;
                  this.customText.recomendacion1 = this.recomendacion1Text();
                  this.processPreliminarText = false;
                }
                
                
            break;
            case 2:
              this.$v.antecedentes.$touch()
              if(this.$v.antecedentes.$invalid )
                  return false;
                
            break;
            case 3:
              this.$v.customText.$touch()
              if(this.$v.customText.$invalid )
                  return false;
            break;
            case 4:
              // var checked = 
              if(!this.acceptTerms){
                  return false;
              }
              this.sendCounter();
              let e = this.getPretensionContract();

              pdfMake.createPdf(e.getContractObject()).getDataUrl(function (outDoc) {
                  document.getElementById('pdfV').src = outDoc;
              });
  
              //fireStore.saveContract(contrato);
  
              break;
            default:
            break;
  
        }
        return true; //return false if you want to prevent moving to next page
      },
      downloadPretension(){
        let e = this.getPretensionContract();
        pdfMake.createPdf(e.getContractObject()).download(this.fileName);
  
      },
      getPretensionContract(){
        this.customText.sentidoDeLaCondena = this.sentidoDeLaCondenaText() + this.customText.sentidoDeLaCondena2;
        this.customText.recomendacion1 = this.recomendacion1Text() + this.customText.sentidoDeLaCondena2;
        this.proceso.pretension = this.proceso.pretension1 + ' - '+this.proceso.clasePretension;
        if(this.proceso.clasePretension =='Requisitos_No_Activo'){
          this.proceso.pretension = this.proceso.pretension1
        }
        if(this.proceso.clasePretension =='Reliquidacion 80%'){
          this.proceso.pretension = this.proceso.pretension1+ ' - Reliquidación';
        }
        let contrato = { 
                  proceso: this.proceso,
                  responsable: this.responsable,
                  aoe: this.aoe,
                  cumplimiento: this.cumplimiento,
                  cuantiaDeLaPension: this.cuantiaDeLaPension,
                  antecedentes: this.antecedentes,
                  tipo: 'Pretension',
                  fileName: this.fileName,
                  customText: this.customText
              }
              // console.log('pretension',JSON.stringify(contrato));
  
              var e = new pretension(contrato)
              if(this.responsable.silencioAdministrativo){
                e = new pretensionSilencioAdministrativo(contrato)
              }
              return e;
      },
      backClicked(currentPage) {
        console.log('back clicked', currentPage);
        return true; //return false if you want to prevent moving to previous page
      },
      isEmptyOrNotNull(obj) {
        return obj !== null && obj !== undefined && Object.keys(obj).length === 0 && obj.constructor === Object;
      },
      preloadedData(){
        
        this.proceso.sentencia= 'Sentencia';
        this.proceso.jurisdiccion= 'Ordinaria';
        this.proceso.afiliado= 'Michael Perez';
        this.proceso.cedula= '1130400566';
        this.proceso.radicado= '11232093034849557845756';
        this.proceso.despacho1= 'Juzgado 1 laboral del circuito de Cali';
        this.proceso.despacho2= 'Juzgado 2 laboral del circuito de Cali';
        this.proceso.fechaFallo1= '28/11/2023';
        this.proceso.fechaFallo2= 'n/a';
        this.proceso.pretension1= 'Vejez';
        this.proceso.clasePretension= 'Indemnización Sustitutiva - Reliquidación';
        this.proceso.tipoDemanda= 'demanda ordinaria laboral';

        
        this.responsable.nombre= 'Marcela Andrea Zuleta Murgas';
        this.responsable.cargo= 'Subdirectora de Determinación VIII - Colpensiones';

        this.aoe.oae= 'SUB 140383 del 23 de mayo de 2022';
        this.aoe.sustanciador= 'Julian Julianes';
        this.aoe.revisor= 'Marcelo Marcell';

        this.cumplimiento.acto= 'SUB 345862 del 12 de diciembre de 2023';
        this.cumplimiento.fechaPago= '2 de febrero de 2024';
        this.cumplimiento.valorNeto= '$ 1.628.262';
          
        this.cuantiaDeLaPension= '$XXXX';
        
        this.antecedentes.reconocimiento= 'XXXX';
        this.antecedentes.numeroSemanas= 'XXXX';
        this.antecedentes.cuantiaInicial= '$XXXX';
        
      },
      loadVejezRequisitos80Model(){
        var sentidoDeLaCondena2 = `reliquidar la pensión de vejez de ${this.proceso.afiliado}, teniendo en cuenta una tasa de reemplazo del 80%`;
        var antecedentesText = `Se encuentra que mediante la Resolución xxxx, Colpensiones reconoció el pago de la pensión de vejez, a favor de ${this.proceso.afiliado}, en cuantía de xxxx a partir del xxx. 

Posteriormente, mediante la Resolución ${this.aoe.oae}, Colpensiones negó la solicitud de reliquidación de la pensión de vejez, teniendo en cuenta que no se generaron valores a favor.

Inconforme con la decisión de la Entidad, ${this.proceso.afiliado} decide interponer demanda de conocimiento del ${this.proceso.despacho1}, despacho judicial que ordenó a Colpensiones xxxxxxxxxxxxx

Colpensiones, dio cumplimiento al fallo judicial, a través del Acto Administrativo ${this.cumplimiento.acto}.`;
        var analisis1Text = `Al examinar la documentación del caso objeto de estudio, se encuentra que mediante la Resolución xxxx, Colpensiones reconoció el pago de la pensión de vejez, a favor de ${this.proceso.afiliado}, en cuantía de xxxx a partir del xxx. 

Posteriormente, mediante la Resolución ${this.aoe.oae}, Colpensiones negó la solicitud de reliquidación de la pensión de vejez, teniendo en cuenta que no se generaron valores a favor.`;

        var analisis2Text = `En ese sentido, una vez validada la información que reposa en el acto administrativo objeto de estudio, se tuvo que ${this.proceso.afiliado} solicitó ante Colpensiones la reliquidación de su prestación, acreditando XXX semanas al Sistema General de Pensiones.

Por consiguiente, se aplicó lo dispuesto en el artículo 21 de la Ley 100 de 1993 para calcular el IBL y el artículo 34 de la Ley 100 de 1993, modificado por el artículo 10 de la Ley 797 de 2003 respecto al monto de la prestación, tomando los factores salariales establecidos en los artículos 18 y 19 de la Ley 100 de 1993 y el artículo 01 del Decreto 1158 del 03 de junio de 1994, procediendo a efectuar las operaciones aritméticas que no arrojaron valores a favor del pensionado, razón por la cual, se negó la solicitud de reliquidación pensional. 

En el caso bajo estudio se encuentra que, si bien es cierto el asegurado cotizó semanas adicionales al mínimo exigidas por la norma, también lo es que resultaría improcedente realizar el cálculo con la totalidad de las misma en razón a que, de conformidad con las disposiciones contenidas en la Ley 100 de 1993 y la Ley 797 de 2003, solo se tendrán en cuenta hasta 500 semanas adicionales las cuales permitirían alcanzar el porcentaje máximo de liquidación de la prestación, esto es, el 80%, siempre y cuando al aplicar la formula contenida en el articulo 34 de la Ley 100 de 1993, así lo determine, pues este porcentaje pude oscilar entre el 80 y el 70.5%, en forma decreciente en función del nivel de ingresos de cotización.

El funcionario resolvió la solicitud de reliquidación de conformidad con la normatividad aplicable y bajo los lineamientos institucionales que sobre la materia recientemente ha emitido la entidad para resolver las solicitudes relacionadas con la aplicación de la sentencia SL 3501-2022, en lo que respecta a la reliquidación de prestaciones que superan las 1800 semanas de cotización.

Una muestra de lo anterior es el contenido del memorando OAL – 016 del 25 de enero de 2023 en donde la Oficina Asesora de Asuntos Legales de Colpensiones consideró prudente conservar la línea ya fijada correspondiente a liquidar la tasa de reemplazo, es decir, teniendo en cuenta hasta 1800 semanas de cotización, ya que aún no se cierra el debate respecto a este precedente judicial y la entidad activará los medios de control que brinda la Carta Política, a efectos de que se module esta decisión por el Tribunal Constitucional.
`;
        let returnObject = {Analisis1: analisis1Text, Analisis2: analisis2Text, Antecedentes: antecedentesText,SentidoDeLaCondena2: sentidoDeLaCondena2};
        return returnObject;
      },
      loadAuxiliosFunerariosNoActivoModel(){
        var sentidoDeLaCondena2 = `ordenó a Colpensiones reconocer y pagar la suma de xxxx debidamente indexada, por concepto de auxilio funerario, a favor de ${this.proceso.afiliado}.`;
        var antecedentesText = `Se encuentra que mediante Resolución ${this.aoe.oae}, Colpensiones negó el reconocimiento y pago del auxilio funerario solicitado por ${this.proceso.afiliado}, con ocasión del fallecimiento de xxxxx.

Inconforme con la decisión, decide interponer demanda ordinaria laboral de conocimiento del ${this.proceso.despacho1}, despacho judicial que ordenó a Colpensiones reconocer y pagar la suma de $ XXXXX por concepto de auxilio funerario, a favor de ${this.proceso.afiliado}.

Colpensiones, dio cumplimiento al fallo judicial, a través del Acto Administrativo SUB 135900 del 24 de mayo de 2023.`;
        var analisis1Text = `Al examinar la documentación del caso objeto de estudio, se encuentra que mediante Resolución ${this.aoe.oae}, Colpensiones negó el reconocimiento y pago del auxilio funerario solicitado por ${this.proceso.afiliado}, con ocasión del fallecimiento de XXX.`;
        var analisis2Text = `En ese sentido, una vez validada la información que reposa en el acto administrativo objeto de estudio, se encuentra que con ocasión del fallecimiento de xx ocurrido el xxx, se presentó ${this.proceso.afiliado} a solicitar el reconocimiento y pago del auxilio funerario.
 
Por consiguiente, se aplicó lo dispuesto en el artículo 51 de la Ley 100 de 1993, en concordancia con lo dispuesto en el artículo 18 del Decreto 1889 de 1994, referente al reconocimiento y pago del auxilio funerario, el cual dispone: “La persona que compruebe haber sufragado los gastos de entierro de un afiliado o pensionado, tendrá derecho a percibir un auxilio funerario equivalente al último salario base de cotización, o al valor correspondiente a la última mesada pensional recibida, según sea el caso, sin que este auxilio pueda ser inferior a cinco (5) salarios mínimos legales mensuales vigentes, ni superior a diez (10) veces dicho salario. Cuando los gastos funerarios por disposición legal o reglamentaria deban estar cubiertos por una póliza de seguros, el Instituto Seguros Sociales, cajas, fondos o entidades del sector público podrán repetir contra la entidad aseguradora que lo haya amparado, por las sumas que se paguen por este concepto”.
 
A su vez, la Circular 01 de 2012 señala: 
“8.1. EL AUXILIO FUNERARIO.
Se causa:
a) Al fallecer el pensionado (vejez o Invalidez, no opera para sustituciones o sobrevivientes)
b) Cuando el afiliado, al momento de su fallecimiento, se encontraba al día en el pago de aportes. Los pagos efectuados después de la fecha de fallecimiento tanto para trabajadores dependientes como para independientes, así se realicen con intereses de mora, no genera derecho a auxilio funerario (art. 53 Dto 1406/1999)”.

Por lo anterior, se indicó que no era procedente reconocer tal prestación teniendo en cuenta que el causante al momento de su fallecimiento, no se encontraba como cotizante activo al Sistema General de Pensiones. Así mismo, se aclaró al peticionario que para acceder al reconocimiento pretendido, el afiliado fallecido debía haber sido causante de una pensión de vejez o invalidez o en su defecto cotizante activo ante Colpensiones al momento de su deceso, requisitos que no se acreditaron en vista de que el causante no dejó causado el derecho, razón por la cual, se negó el reconocimiento y pago del auxilio funerario solicitado. Decisión que se encontró conforme a derecho.
`;
        let returnObject = {Analisis1: analisis1Text, Analisis2: analisis2Text, Antecedentes: antecedentesText,SentidoDeLaCondena2: sentidoDeLaCondena2};
        return returnObject;
      },
      loadRequisitosModel(){
        var antecedentesText= `Se encuentra que mediante Resolución ${this.aoe.oae}, Colpensiones negó el reconocimiento y pago de la indemnización sustitutiva de la pensión de vejez, solicitada por ${this.proceso.afiliado}, por presentarse una incompatibilidad legal. 

Inconforme con la decisión, ${this.proceso.afiliado} decide interponer demanda ordinaria laboral de primera instancia de conocimiento del ${this.proceso.despacho1}, despacho judicial que ordenó a Colpensiones reconocer y pagar la suma de ${this.cuantiaDeLaPension}, debidamente indexada, por concepto de indemnización sustitutiva de la pensión de vejez a favor del demandante.

Colpensiones, dio cumplimiento al fallo judicial, a través del Acto Administrativo ${this.cumplimiento.acto}.`;
        var analisis1Text = `Al examinar la documentación del caso objeto de estudio, se encuentra que mediante Resolución ${this.aoe.oae}, Colpensiones negó el reconocimiento y pago de la indemnización sustitutiva de la pensión de vejez, solicitada por ${this.proceso.afiliado}, por presentarse una incompatibilidad legal.`;
        var analisis2Text = `En ese sentido, una vez validada la información que reposa en el acto administrativo objeto de estudio, se tuvo que ${this.proceso.afiliado} solicitó ante Colpensiones el reconocimiento y pago de la indemnización sustitutiva de la pensión de vejez, acreditando «SEMANAS_ACREDITADAS» semanas de cotización al Sistema General de Pensiones.

Por lo anterior, se procedió a consultar el expediente administrativo y la página de bonos pensionales del Ministerio de Hacienda y Crédito Público, evidenciando que el solicitante devengaba una pensión de jubilación por parte del Fondo Nacional de Prestaciones del Magisterio, la cual, era incompatible con la pensión de vejez solicitada en el régimen de prima media.

Por consiguiente, se aplicó lo dispuesto en el artículo 128 de la Constitución Política de Colombia y el artículo 19 de la Ley 4 de 1992, en el entendido de que “Nadie podrá desempeñar simultáneamente más de un empleo público ni recibir más de una asignación que provenga del tesoro público, o de empresas o de instituciones en las que tenga parte mayoritaria el Estado, salvo los casos expresamente determinados por la ley. (…)” 

Frente a este tema, es importante resaltar lo dispuesto por la Corte Constitucional en la sentencia C- 674 del 28 de junio de 2011en donde indicó: “El anterior análisis permite concluir que los imperativos de eficiencia que gobiernan la seguridad social y el carácter unitario de este sistema hacen razonable que el Legislador evite que, en principio, una misma persona goce de dos prestaciones que cumplan idéntica función, pues no sólo eso podría llegar a ser inequitativo, sino que, además, implicaría una gestión ineficiente de recursos que por definición son limitados. Esta situación explica que el artículo 13 de la Ley 100 de 1993, al definir las características generales del sistema de pensiones, haya precisado, en el literal j), que ningún afiliado podrá recibir simultáneamente pensiones. La razón es elemental: estas dos pensiones pretenden proteger a la persona frente a un riesgo común, ya que buscan ampararla en aquellas situaciones en que ella ya no tiene la misma capacidad para seguir trabajando, ya sea por los efectos inevitables de la vejez, o bien por una enfermedad o un accidente que hayan mermado sus facultades laborales.”

En el mismo sentido, Colpensiones a través del Concepto N° BZ2016_11520676 del 28 de Septiembre de 2016 de Colpensiones respecto de la Compatibilidad Magisterio Circular 01 de 2012, que en su apartado de conclusiones dispuso: “(…) d) Conclusiones 1.El literal g) del artículo 19 de la Ley 4 de 1992 establece para los docentes oficiales, la compatibilidad entre la pensión, cualquiera que sea y otra remuneración indicando que solo es procedente para quienes adquirieron su derecho pensional o les fue reconocida su pensión por el Magisterio antes de la entrada en vigencia de la Ley 4ª de 1992. 2. El derecho pensional de un afiliado al FOMAG causado antes del 17 de mayo de 1992 (día anterior a la entrada en vigencia de la Ley 4ª de 1992) resulta compatible con la pensión de vejez causada en el RPMPD del Sistema General de Pensiones en el mismo segmento de tiempo, siempre que ésta última se reconozca con fundamento en cotizaciones provenientes de empleadores particulares o realizadas como trabajador independiente o con empleadores diferentes a los tenidos en cuenta para el reconocimiento de la pensión de jubilación del sector público. 3. El derecho pensional de un afiliado al FOMAG causado entre el 12 de agosto de 1993 y el 20 de diciembre de 2001 (día anterior a la entrada en vigencia de la Ley 715 de 2001), resulta compatible con la pensión de vejez que se cause en el mismo segmento de tiempo en el RPMPD de Sistema General de Pensiones siempre que ésta última se reconozca con fundamento en cotizaciones provenientes de empleadores particulares o realizadas como trabajador independiente o con empleadores diferentes a los tenidos en cuenta para el reconocimiento de la pensión de jubilación del sector público. 4. Para el caso del docente que no se encuentre en las hipótesis anteriores y opte por afiliarse a Colpensiones como entidad administradora de pensiones dentro del Sistema General de Pensiones, conforme al artículo 16 de la Ley 100 de 1993, no se le permite distribuir las cotizaciones obligatorias con el fin de construir su derecho pensional entre dos regímenes del sistema. 5. El derecho pensional de un afiliado al FOMAG resulta incompatible con la pensión de vejez reconocida por el RPMPD de Sistema General de Pensiones si se causa entre el 18 de mayo de 1992 y el 11 de agosto de 1993 (día anterior a la entrada en vigencia de la Ley 60 de 1993); así como el causado entre el 21 de diciembre de 2001 y el 19 de junio de 2002 (día anterior a la entrada en vigencia del Decreto y para aquellos Docentes del sector educativo estatal vinculados a partir de la vigencia del Decreto 1278 de 2002 (20 de junio). 6. Igualmente, los Docentes vinculados a partir de la Ley 812 de 2003 (27 de junio de 2003), que dispuso la inclusión en el Régimen de Prima Media con Prestación Definida de los Docentes, quienes NO gozan de la compatibilidad pensional. 7. Con la entrada en vigencia de la Ley 100 de 1993 se encuentra expresamente prohibida la doble percepción de mesada pensional, cuando se trata de cubrir la misma contingencia o riesgo, como es el caso de la vejez, no siendo posible ser afiliado y pensionado al mismo tiempo al sistema de seguridad social integral. 8. Para los docentes asimilados, la certificación de inscripción al nuevo escalafón en el grado correspondiente acredita que el docente se sometió a una evaluación de desempeño y de competencias aplicadas a otros docentes de la misma formación que permitió superar el periodo de prueba, obtuvo calificación satisfactoria, renunció al cargo anterior y fue nombrado en el nuevo. Lo anterior sin perjuicio de los controles o verificaciones que se deban realizar por tratarse de temas pensionales conforme los previsto el artículo 25 del decreto 019 de 2019. 9. En vigencia de la Ley 100 de 1993, salvo disposición legal en contrario, el carácter incompatible de la pensión de vejez de Colpensiones y FOMAG lo da la misma Ley 100 de 1993 con sus modificaciones previstas en la ley 797 de 2003.”

De lo anterior se puede inferir que únicamente existe compatibilidad pensional en caso de que el jubilado por el Fondo Naciones de Prestaciones del Magisterio cause su status pensional con anterioridad al 17 de mayo de 1992. Así mismo, resulta compatible si el derecho pensional se causó entre el 12 de agosto de 1993 y el 20 de diciembre de 2001, situación fáctica que no acreditó el peticionario, teniendo en cuenta que adquirió su status pensional con posterioridad a esta fecha, razón por la cual, se negó la solicitud incoada por cuanto resultaba incompatible con la que se encontraba percibiendo por parte del Fondo de Prestaciones del Magisterio y que en virtud de lo establecido en la Ley 100 de 1993, al ser un régimen solidario, todos los aportes efectuados por los afiliados sirven de sustento para mantener el Sistema y financiar las pensiones, dentro de un fondo prestacional común.
`;
        let returnObject = {Analisis1: analisis1Text, Analisis2: analisis2Text, Antecedentes: antecedentesText};
        return returnObject;
      },
      loadSilencioAdministrativoModel(){
        var sentidoDeLaCondena2 = `a reconocer y pagar la suma de XXXX por concepto de XXXXXX.`
        var antecedentesText= `Se encuentra que Colpensiones reconoció el pago de xxxxxx, a favor de ${this.proceso.afiliado}, en cuantía de xxxx, a través del Acto Administrativo xxxxxx

Posteriormente, el afiliado, solicitó a Colpensiones XXXXXX, petición que no fue resuelta por la Entidad.

Inconforme decide interponer demanda ordinaria laboral de conocimiento del ${this.proceso.despacho1}, despacho judicial que ordenó a Colpensiones a a reconocer y pagar la suma de XXXX por concepto de XXXXXX.

La Administradora Colombiana de Pensiones dio cumplimiento al fallo judicial, a través del Acto Administrativo ${this.cumplimiento.acto}.
`;
        var analisis1Text = `Al respecto, se tiene que, al examinar la documentación del caso, se evidenció que Colpensiones reconoció el pago de xxxxxx, a favor de ${this.proceso.afiliado}, en cuantía de xxxx, a través del Acto Administrativo xxxxxx

Posteriormente, el afiliado, solicitó a Colpensiones la reliquidación de la indemnización sustitutiva de pensión de vejez; sin embargo, al realizar la búsqueda en el Sistema de Información Bizagi y en el trámite histórico del proceso, se evidenció la ausencia de comunicación o acto administrativo dando respuesta a la solicitud previo a la radicación de la demanda por parte del ciudadano, configurándose así el silencio administrativo negativo, lo que se traduce en la producción de un acto ficto o presunto por parte de la entidad.

Sobre el particular, la H. Corte Constitucional ha señalado que el silencio administrativo negativo es una figura creada por el legislador para los casos en que el administrado no haya recibido respuesta de la administración frente a un requerimiento específico. Dicha figura consiste en que el administrado ha de asumir que el requerimiento elevado ante la autoridad fue negado, una vez agotado el plazo para su respectiva respuesta. Al respecto, dicha Corporación ha expresado:
 
“La regla general en nuestro ordenamiento ha sido que agotados los plazos que tiene la administración para dar respuesta a un requerimiento de carácter general o individual sin que aquella se produzca, ha de entenderse negado el requerimiento. Esta figura ha sido denominada silencio administrativo negativo y consiste en una ficción para que, vencidos los plazos de ley sin una respuesta por parte de la administración, se genere un acto ficto por medio del cual se niega la solicitud elevada, acto que el administrado puede recurrir ante la misma administración o la jurisdicción.” 
 
Como se puede observar, el silencio administrativo negativo es una expresión del derecho de petición, en tanto que se trata de un mecanismo para que el ciudadano haga valer sus derechos ante la administración de justicia, el cual no es más que la presunción de negativa de la administración por el hecho de no haber resuelto la petición o recurso, para los efectos del estudio de la acción de repetición frente la actuación administrativa, no reviste responsabilidad de un agente, en tanto estamos frente a una ficción jurídica.
 
Así las cosas, al entrar a evaluar el elemento subjetivo en relación a la conducta del funcionario, resulta escaso el material probatorio aportado por la plataforma Bizagi, por lo cual, no es posible determinar si la conducta del funcionario que se encontraba obligado a dar respuesta a la solicitud del ciudadano, revistió dolo o culpa grave. Por otra parte, también debe tenerse en cuenta la posibilidad de no haberse dado respuesta a la solicitud del ciudadano –silencio administrativo- por parte de la entidad, escenario que explicaría la ausencia del acto administrativo que se pronuncie de fondo o resuelva la solicitud del ciudadano. Según esto y teniendo en cuenta los parámetros legales y jurisprudenciales entorno a la acción de repetición, resultaría improcedente la acción para el caso objeto de estudio.
`;
        var analisis2Text = ``;
        let returnObject = {Analisis1: analisis1Text, Analisis2: analisis2Text, Antecedentes: antecedentesText, SentidoDeLaCondena2: sentidoDeLaCondena2};
        return returnObject;
      },
      sentidoDeLaCondenaText(){
        let returnedText = `Con fundamento en la sentencia proferida por el ${this.proceso.despacho1}, en el proceso con radicado ${this.proceso.radicado}, se ordenó a Colpensiones `;
        if(this.proceso.sentencia == 'Concilación'){
          returnedText = `Con fundamento en la sentencia proferida por el ${this.proceso.despacho1}, en el proceso con radicado ${this.proceso.radicado}, que aprobó acuerdo conciliatorio en el que Colpensiones se dispuso a `;  
        }
        if(this.proceso.modificaChecked){
          returnedText = `Con fundamento en la sentencia proferida por el ${this.proceso.despacho1}, en el proceso con radicado ${this.proceso.radicado}, modificado por el ${this.proceso.despacho2}, se ordenó a Colpensiones `;  
        }
        if(this.proceso.revocaChecked){
          returnedText = `Con fundamento en la sentencia proferida por el ${this.proceso.despacho2}, en el proceso con radicado ${this.proceso.radicado}, se ordenó a Colpensiones `;  
        }
        if(this.proceso.confirmaChecked){
          returnedText = `Con fundamento en la sentencia proferida por el ${this.proceso.despacho1}, en el proceso con radicado ${this.proceso.radicado}, confirmado por el ${this.proceso.despacho2}, se ordenó a Colpensiones `;  
        }
        return returnedText;
      },
      sentidoDeLaCondena2Text(){
        let returnedText = `reliquidar el pago de la indemnización Sustitutiva de la pensión de vejez, a favor de ${this.proceso.afiliado}, en cuantía de ${this.cuantiaDeLaPension}`;
        if(this.responsable.silencioAdministrativo){
          returnedText = this.loadSilencioAdministrativoModel().SentidoDeLaCondena2;
        }
        if(this.proceso.clasePretension =='Requisitos_No_Activo'){
          returnedText = this.loadAuxiliosFunerariosNoActivoModel().SentidoDeLaCondena2;
        }
        if(this.proceso.clasePretension =='Reliquidacion 80%'){
          returnedText = this.loadVejezRequisitos80Model().SentidoDeLaCondena2;
        }
        return returnedText;
      },
      antecedentesText(){
        let returnedText = `Se encuentra que Colpensiones reconoció el pago de la indemnización sustitutiva de la pensión de vejez, a favor de ${this.proceso.afiliado}, a través del Acto Administrativo ${this.antecedentes.reconocimiento}, en cuantía de ${this.antecedentes.cuantiaInicial}.

Posteriormente, mediante la Resolución ${this.aoe.oae}, se negó la solicitud de reliquidación de la indemnización sustitutiva de la pensión de vejez.

Inconforme con la decisión, el ciudadano decide interponer ${this.proceso.tipoDemanda} de conocimiento del ${this.proceso.despacho1}, despacho judicial que ordenó a Colpensiones reliquidar el pago de la indemnización Sustitutiva de la pensión de vejez, a favor de ${this.proceso.afiliado}, en cuantía de ${this.cuantiaDeLaPension}.

Colpensiones, dio cumplimiento al fallo judicial, a través del Acto Administrativo ${this.cumplimiento.acto}.`;
        console.log('test Antecedentes text')
      if(this.proceso.clasePretension =='Indemnización Sustitutiva - Requisitos'){
        returnedText = this.loadRequisitosModel().Antecedentes;
      }
      if(this.proceso.clasePretension =='Requisitos_No_Activo'){
        returnedText = this.loadAuxiliosFunerariosNoActivoModel().Antecedentes;
      }
      if(this.proceso.clasePretension =='Reliquidacion 80%'){
        returnedText = this.loadVejezRequisitos80Model().Antecedentes;
      }
      if(this.responsable.silencioAdministrativo){
        returnedText = this.loadSilencioAdministrativoModel().Antecedentes;
      }
        return returnedText;
      },
      analisis1Text(){
        let returnedText = `Al examinar la documentación del caso objeto de estudio, se encuentra que Colpensiones reconoció el pago de la indemnización sustitutiva de la pensión de vejez, a favor de ${this.proceso.afiliado}, a través del Acto Administrativo ${this.antecedentes.reconocimiento}, teniendo en cuenta ${this.antecedentes.numeroSemanas} semanas cotizadas al Sistema General de Pensiones.
                  
Posteriormente, mediante la Resolución ${this.aoe.oae}, se negó la solicitud de reliquidación de la indemnización sustitutiva de la pensión de vejez.`;
      if(this.proceso.clasePretension =='Indemnización Sustitutiva - Requisitos'){
        returnedText = this.loadRequisitosModel().Analisis1;
      }
      if(this.proceso.clasePretension =='Requisitos_No_Activo'){
        returnedText = this.loadAuxiliosFunerariosNoActivoModel().Analisis1;
      }
      if(this.proceso.clasePretension =='Reliquidacion 80%'){
        returnedText = this.loadVejezRequisitos80Model().Analisis1;
      }
      if(this.responsable.silencioAdministrativo){
        returnedText = this.loadSilencioAdministrativoModel().Analisis1;
      }
        return returnedText;
      },
      analisis2Text(){
        let returnedText = `En ese sentido, una vez validada la información que reposa en el acto administrativo objeto de estudio, se tuvo que ${this.proceso.afiliado}, solicitó ante Colpensiones que se reliquidara el pago de la indemnización sustitutiva de la pensión de vejez que le fue reconocida, acreditando ${this.antecedentes.numeroSemanas} semanas cotizadas.

Por consiguiente, se aplicó lo dispuesto en el artículo 3 del Decreto 1730 de 2001, referente a la liquidación de la indemnización sustitutiva de la pensión de vejez, el cual dispone:

ARTICULO 3º. -Cuantía de la indemnización. Para determinar el valor de la indemnización se aplicará la siguiente formula:,
I = SBC x SC x PPC
Donde:
SBC: Es el salario base de la liquidación de la cotización semanal promediado de acuerdo con los factores señalados en el Decreto 1158 de 1994, sobre los cuales cotizó el afiliado a la administradora que va a efectuar el reconocimiento, actualizado anualmente con base en la variación del IPC según certificación del DANE.
SC: Es la suma de las semanas cotizadas a la administradora que va a efectuar el reconocimiento.
PPC: Es el promedio ponderado de los porcentajes sobre los cuales ha cotizado el afiliado para el riesgo de vejez, invalidez o muerte por riesgo común, a la administradora que va a efectuar el reconocimiento.

En el evento de que, con anterioridad a la vigencia de la Ley 100 de 1993, la administradora que va a efectuar el reconocimiento no manejara separadamente las cotizaciones de los riesgos de vejez, invalidez o muerte por riesgo común de las correspondientes al riesgo de salud, se aplicará la misma proporción existente entre las cotizaciones para el riesgo de vejez de que trata el inciso primero del artículo 20 de la Ley 100 de 1993 (10%) y las cotizaciones para el riesgo de salud señaladas en el artículo 204 de la misma ley (12%), es decir se tomarán como cotizaciones para el riesgo de vejez el equivalente al 45.45% de total de la cotización efectuada y sobre este resultado se calculará la indemnización sustitutiva.

A partir de la vigencia de la Ley 100 de 1993, se tomará en cuenta el porcentaje de cotización establecido en el inciso primero del artículo 20 de la Ley 100 de 1993.

De acuerdo con la norma anteriormente mencionada, se procedió a realizar un nuevo estudio de reliquidación de la indemnización sustitutiva de la pensión de vejez, en el cual, no se generaron valores a favor del peticionario que permitieran incrementar el valor de su prestación, razón por la cual, no se accedió a lo pretendido. Decisión que se encontró ajustada a derecho.`;
      if(this.proceso.clasePretension =='Indemnización Sustitutiva - Requisitos'){
        returnedText = this.loadRequisitosModel().Analisis2;
      }
      if(this.proceso.clasePretension =='Requisitos_No_Activo'){
        returnedText = this.loadAuxiliosFunerariosNoActivoModel().Analisis2;
      }
      if(this.proceso.clasePretension =='Reliquidacion 80%'){
        returnedText = this.loadVejezRequisitos80Model().Analisis2;
      }
      if(this.responsable.silencioAdministrativo){
        returnedText = this.loadSilencioAdministrativoModel().Analisis2;
      }
        return returnedText;
      },
      analisisNonEditableText(){
        let returnedText = `Para determinar cuál fue la actuación de la administración que generó la inconformidad del ciudadano y su posterior intervención ante la justicia ${this.proceso.jurisdiccion.toLowerCase()}, se tendrá como acto objeto de estudio el acto administrativo ${this.aoe.oae} por ser esta la decisión en firme emitida por esta administradora respecto de la prestación solicitada por el asegurado.`;
        if(this.responsable.silencioAdministrativo){
          returnedText = '';
        }
        return returnedText;
      },
      recomendacion1Text(){
        let returnedText = `Existencia de un fallo condenatorio: se verifica con el fallo que ordenó a Colpensiones `;
        if(this.proceso.sentencia == 'Concilación'){
          returnedText = `1.	Existencia de un fallo condenatorio o conciliación: se verifica con el fallo que aprobó el acuerdo conciliatorio en el que Colpensiones se dispuso a `;
        }
        return returnedText;
      },
      updateOptions() {
          this.dependentOptions = this.optionsMap[this.proceso.pretension1];
          this.selectedDependent = ''; // Reset the dependent dropdown selection
        },
        updatePretensionText(){
            this.proceso.pretension = this.proceso.pretension1 + ' - '+this.proceso.clasePretension;
        },
        formatFechaCasacion() {
            if (this.proceso.fechaCasacion1) {
              const date = new Date(this.proceso.fechaCasacion1);
              const day = String(date.getDate()).padStart(2, '0');
              const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
              const year = date.getFullYear();
              this.proceso.fechaCasacion = `${day}-${month}-${year}`;
            } else {
                this.proceso.fechaCasacion = '';
            }
          },
          updateModelAnalisis1(e){
            e.stopPropagation()
            this.customText.analisis1 = "";
            this.customText.analisis1 = e.target.innerText;
            e.stopPropagation()
          },
          updateModelAnalisis2(e){
            e.stopPropagation()
            this.customText.analisis2 = e.target.innerText;

          },
          handleClickNonEdit(e){
            
            console.log('Non Edit')
            console.log(e)
            e.stopPropagation();
          },
          handleClickEdit(e){
            console.log('Edit')
            e.stopPropagation();
          },
          handleClickMainDiv(e){
            console.log('MainDiv')
            e.stopPropagation();
          },
          updateSilencioAdministrativo(){
            // if(this.responsable.silencioAdministrativo){
              this.responsable.nombre = 'Silencio Administrativo Negativo'
              this.responsable.cargo = 'N/A'
              this.aoe.oae = 'Acto ficto o presunto'
              this.aoe.sustanciador = 'N/A'
              this.aoe.revisor = 'N/A'
            // }
          },
          confirmLeaving(){
            event.preventDefault();
            return "Deseas continuar? algunos cambios se pueden perder."
          },
          async sendCounter(){
            var payload={
              legalFileId: this.proceso.radicado,
              userId: this.user.email,
              templateId: 'PretensionAvanzado'
            }
            console.log(JSON.stringify(payload))
            try {
              const response = await fetch('https://legiox-docs.vercel.app/records', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
              });

              if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
              }

              const data = await response.json();
              console.log('AWESOME Response:', data);
            } catch (error) {
              console.error('There was an error!', error);
            }
          }
    },
    validations: {
        proceso: {
          sentencia: {required},
          jurisdiccion: {required},
          afiliado: {required},
          cedula: {required},
          radicado: {required},
          despacho1: {required},
          fechaFallo1:{required},
          pretension: {required}
        },
        responsable:{
          nombre: {required: requiredUnless('isOptional')},
          // nombre: {required},
          cargo: {required: requiredUnless('isOptional')},
        },
        aoe: {required},
        cumplimiento:{
          acto: {required},
          fechaPago: {required},
          valorNeto: {required},
        },
        cuantiaDeLaPension: {required},
        antecedentes:{
          reconocimiento: {required},
          cuantiaInicial: {required},
          numeroSemanas: {required}
        },
        customText:{
          sentidoDeLaCondena: {required},
          antecedentes: {required},
          analisis1: {required},
          // analisis2: {required},
          // analisis3: {required}
        },

        lastName: {
        required
        }
    },
    watch: {
      '$route': function () {
        console.log('Route Changed!!!!')
        window.confirm('Not saved, are you sure you want to navigate away?'); //{
        // do something ...
      }
    },
    created () {
      console.log('Entro a Pretension')
      window.addEventListener('beforeunload', this.confirmLeaving)
      // this.preloadedData();
      this.updateOptions();
      console.log(this.uploadedData)
      var isEmpty = (this.uploadedData === null);
      if(!isEmpty ){
        console.log('Uploaded data not empty ')
        for (const key of Object.keys(this.uploadedData)) {
          switch (key.trim()) {
            case 'proceso.cedula':
            case 'CEDULA AFILIADO':
              console.log(`Cedula  Handling ${key}: ${this.uploadedData[key]}`);
              this.proceso.cedula = this.uploadedData[key];
              break;
            case 'proceso.afiliado':
            case 'NOMBRE OK':
            case 'NOMBRES Y APELLIDOS  AFILIADO':
              console.log(`Handling ${key}: ${this.uploadedData[key]}`);
              this.proceso.afiliado = this.uploadedData[key];
              break;
            case 'proceso.despacho1':
            case 'DESPACHO':
              console.log(`Handling ${key}: ${this.uploadedData[key]}`);
              this.proceso.despacho1 = this.uploadedData[key];
              break;
            case 'proceso.radicado':
            case 'RADICADO 23 DIGITOS':
              console.log(`Handling ${key}: ${this.uploadedData[key]}`);
              this.proceso.radicado = this.uploadedData[key];
              break;
            case 'cumplimiento.acto':
            case 'CUMPLIMIENTO':
            case 'RESOLUCION CUMPLIMIENTO':
              console.log(`Handling ${key}: ${this.uploadedData[key]}`);
              this.cumplimiento.acto = this.uploadedData[key];
              break;
            case 'cumplimiento.fechaPago':
            case 'FECHA DE PAGO OK':
            case 'FECHA DE PAGO':
              console.log(`Handling ${key}: ${this.uploadedData[key]}`);
              this.cumplimiento.fechaPago = this.uploadedData[key];
              break;
            case 'cumplimiento.valorNeto':
            case 'VALOR_NETO_GIRADO':
              console.log(`Handling ${key}: ${this.uploadedData[key]}`);
              this.cumplimiento.valorNeto = this.uploadedData[key];
              break;
            case 'Nombre_Archivo':
            case 'NOMBRE ARCHIVO':
              console.log(`Handling ${key}: ${this.uploadedData[key]}`);
              this.fileName = this.uploadedData[key];
              break;
            default:
              console.log(`Unhandled key: ${key}`);
              // Handle default case or other keys
          }
        }
      }
      // this.$store.dispatch('fetchUser2')
    },
    beforeRouteLeave(to, from, next) {
      // Check if there are unsaved changes, or you can conditionally check other things
      console.log('Before Leaving');
      if (true) {
        const answer = confirm("You have unsaved changes, do you really want to leave?");
        if (answer) {
          next(); // Proceed with the navigation
        } else {
          next(false); // Cancel the navigation
        }
      } else {
        next(); // Proceed with navigation if no unsaved changes
      }
    }
  };
  </script>
  <style>
  .wizard__next{
    background-color: #4f4fe0 !important;
  }
  .wizard__back{
    background-color: #4f4fe0 !important;
  }
  .form-datos div{
      display: block;
      padding-top: 5px;
  }
  .input {
      margin: 5px auto;
    }
  
    .input label {
      display: block;
      color: #000000;
      margin-bottom: 6px;
      font-weight: 500;
    }
  
    .input.inline label {
      display: inline;
    }
  
    .input input {
      font: inherit;
      width: 100%;
      padding: 6px 12px;
      box-sizing: border-box;
      border: 1px solid #ccc;
    }
    .input input[type='checkbox']{
        font: inherit;
      width: auto !important;
      padding: 6px 12px;
      box-sizing: border-box;
      border: 1px solid #ccc;
    }
  
    .checkbox-label{
        display: inline !important;
    }
  
    .input textarea {
      font: inherit;
      width: 100%;
      padding: 6px 12px;
      box-sizing: border-box;
      border: 1px solid #ccc;
    }
  
    .input.inline input {
      width: auto;
    }
  
    .input input:focus {
      outline: none;
      border: 1px solid #521751;
      background-color: #eee;
    }
  
    .input.invalid label {
      color: red;
    }
  
    .input.invalid input {
      border: 1px solid red;
      background-color: #ffc9aa;
    }
  
    .input.invalid textarea {
      border: 1px solid red;
      background-color: #ffc9aa;
    }
  
    .input select {
      border: 1px solid #ccc;
      font: inherit;
    }
  
    .hobbies button {
      border: 1px solid #521751;
      background: #521751;
      color: white;
      padding: 6px;
      font: inherit;
      cursor: pointer;
    }
  
    .hobbies button:hover,
    .hobbies button:active {
      background-color: #8d4288;
    }
  
    .hobbies input {
      width: 90%;
    }
  
    .submit button {
      border: 1px solid #521751;
      color: #521751;
      padding: 10px 20px;
      font: inherit;
      cursor: pointer;
    }
  
    .submit button:hover,
    .submit button:active {
      background-color: #521751;
      color: white;
    }
  
    .submit button[disabled],
    .submit button[disabled]:hover,
    .submit button[disabled]:active {
      border: 1px solid #ccc;
      background-color: transparent;
      color: #ccc;
      cursor: not-allowed;
    }
  
    .wizard__body__step{
      max-width: 80%;
      margin: 0 auto;
      min-height: 520px;
    }

    select{
        width: 35%;
    }

    .hidden{
        display: none !important;
    }
    .visible {
      display: block;
      background-color: #eef0f2; /* Light blue background color f0f8ff */
      padding: 10px;
      margin-top: 10px;
      border: 1px solid #dcdcdc;
      border-radius: 5px;
    }
    .editInsideDiv{
        outline: none;
        color: #495057;
    }
    #textarea {
        -moz-appearance: textfield-multiline;
        -webkit-appearance: textarea;
        border: 1px solid #cccccc;
        height: 450px;
        overflow: auto;
        padding: 2px;
        resize: both;
        white-space: pre-wrap
    }
  </style>
  


// WEBPACK FOOTER //
// src/components/contractWizards/pretensionAvanzado.vue